<div class="products-view__body">
    <div class="products-view__loader"></div>
    <ng-container>
        <div
            class="products-view__options view-options"
            [class.view-options--offcanvas--always]="offCanvasSidebar === 'always'"
            [class.view-options--offcanvas--mobile]="offCanvasSidebar === 'mobile'"
        >
            <div class="view-options__body">
                <button type="button" class="view-options__filters-button filters-button" (click)="sidebar.open()">
                    <span class="filters-button__icon"><app-icon icon="filters-16"></app-icon></span>
                    <span class="filters-button__title">Filter</span>
                </button>



                <div class="view-options__legend">

                </div>

                <div class="view-options__spring"></div>

                <!-- <div class="view-options__select">
                    <label for="view-option-sort">{{ 'INPUT_SORT_LABEL'|translate }}:</label>
                    <select id="view-option-sort" class="form-control form-control-sm" [formControl]="sortControl">
                        <option value="default">{{ 'INPUT_SORT_OPTION_DEFAULT'|translate }}</option>
                        <option value="name_asc">{{ 'INPUT_SORT_OPTION_NAME_ASC'|translate }}</option>
                        <option value="name_desc">{{ 'INPUT_SORT_OPTION_NAME_DESC'|translate }}</option>
                    </select>
                </div>
                <div class="view-options__select">
                    <label for="view-option-limit">{{ 'INPUT_LIMIT_LABEL'|translate }}:</label>
                    <select id="view-option-limit" class="form-control form-control-sm" [formControl]="limitControl">
                        <option value="8">8</option>
                        <option value="16">16</option>
                        <option value="24">24</option>
                        <option value="32">32</option>
                    </select>
                </div> -->
            </div>


        </div>

        <div
            class="products-view__list products-list"
            [attr.data-layout]="layout === 'grid-with-features' ? 'grid' : layout"
            [attr.data-with-features]="layout == 'grid-with-features' ? 'true' : 'false'"
            [class.products-list--grid--6]="gridLayout === 'grid-6-full'"
            [class.products-list--grid--5]="gridLayout === 'grid-5-full'"
            [class.products-list--grid--4]="['grid-4-full', 'grid-4-sidebar'].includes(gridLayout)"
            [class.products-list--grid--3]="gridLayout === 'grid-3-sidebar'"
        >

            <div *ngIf="data?.length == 0" class="products-view__empty">
                <div class="products-view__empty-title">
                    No matching data
                </div>
            </div>

            <div class="products-list__content" *ngIf="data">
                <div *ngFor="let product of data" class="products-list__item">
                    <app-product-card  [product]="product"></app-product-card>
                </div>
            </div>
        </div>

    </ng-container>
</div>
